import React from 'react';
import update from 'react-addons-update';
import classnames from 'classnames';
import LabelInput from './../forms/labelInput';
import SelectRiskRating from './../forms/SelectRiskRating';
import SelectOptions from './../forms/SelectOptions';
import RadioCheckbox from './../forms/RadioCheckbox';

import SelectOccupationRating from './../forms/SelectOccupationRating';
import GetHelp from './../forms/GetHelp';
import RadioToggle from './../forms/RadioToggle';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-100475676-1');

class AboutYourself extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      panel1Edit: '',
      hasErrors: null,      
      questionsAnswered: null,
      step1Inactive: false,
      disableButton: false,
      disableNext: true,
      userInputs: {
        age: null,
        existingMember: null,
        police: null,
        riskRating: '0',
        occupationalRating: null
      }
    };

    this.age = this.age.bind(this);
    this.ageBlur = this.ageBlur.bind(this);

    this.getExistingMember = this.getExistingMember.bind(this);
    this.police = this.police.bind(this);
    this.riskRating = this.riskRating.bind(this);
    this.questionsAnswered = this.questionsAnswered.bind(this);

    this.hasErrors = this.hasErrors.bind(this);

    this.handleClick = this.handleClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.occupationalRatingSelect = this.occupationalRatingSelect.bind(this);
    this.occupationalRatingDropDown = this.occupationalRatingDropDown.bind(this);
    this.radioOnChange = this.radioOnChange.bind(this);
  }


    shouldComponentUpdate(nextProps, nextState) {
      if(nextProps.step1Inactive === true) {
        return true;
      }

      if(this.state.userInputs.existingMember == null && nextState.userInputs.existingMember == 0) {
        this.setState(prevState => ({
          userInputs: {
            ...prevState.userInputs,
            police: '0'
          }
        }));
      }

      if((this.state.userInputs.police === null && nextState.userInputs.police === '1') || (this.state.userInputs.police === '0' && nextState.userInputs.police === '1')) {
        this.setOccupationalRatingPolice();
      } else if(this.state.userInputs.police === '1' && nextState.userInputs.police === '0') { 
        this.resetOccupationalRating();
      }

      if(this.state.userInputs.existingMember === '1' && nextState.existingMember === '0') {
        this.setState(prevState => ({
          userInputs: {
            ...prevState.userInputs,
            police: '0'
          }
        }), () => this.props.callbackParent(this.state.userInputs.police));        
        this.resetUserInputs();
      } else if(this.state.userInputs.existingMember === '0' && nextState.existingMember === '1') {
        this.resetUserInputs();
      }

      if(this.state.userInputs.occupationalRating === null && nextState.userInputs.occupationalRating !== null) {
      } else if(this.state.userInputs.occupationalRating !== null && nextState.userInputs.occupationalRating === null) {
        this.setState({
          disableNext: true
        }, this.props.callbackParent(this.state.disableNext));
      }

      // if(this.state.userInputs.riskRating === '1' && nextState.userInputs.riskRating === '0') {
      //   this.resetOccupationalRating();
      // } else if(this.state.userInputs.riskRating === '0' && nextState.userInputs.riskRating === '1') {
      //   this.resetQuestions();
      // }

      return nextState !== this.state;
    }

  age = (event) => {
    event.persist();
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        age: event.target.value
      }
    }));
  }

  ageBlur(e) {
    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Added input',
      label: 'What is your Age?',
      value: parseInt(e.target.value)
    });
  }

  getExistingMember(component) {    
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        existingMember: component
      }
    }));

    // if(component == 0) {
    //   this.setState({
    //     police: '0'
    //   },() => this.props.callbackParent(this.state.police));
    // }
    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Select yes / no',
      label: 'Existing QSuper account?',
      value: parseInt(component)
    });
  }

  police(component){
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        police: component
      }
    }));

    if(component === '1') {
      this.setState(prevState => ({
        userInputs: {
          ...prevState.userInputs,
          occupationalRating: 'High risk'
        }
      }));
    }

    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Select yes / no',
      label: 'Are you police officer?',
      value: parseInt(component)
    });
  }

  riskRating(component){
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        riskRating: component
      }
    }));

    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Complete questionnaire || Select occupational rating',
      value: parseInt(component)
    });
  }

  occupationalRatingSelect(component) {
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        occupationalRating: component
      }
    }));
    
    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Select occupational rating',
      label: component,
    });
  }

  questionsAnswered(component) {
    this.setState({
      questionsAnswered: component
    });

    ReactGA.event({
      category: 'Tell us about yourself',
      action: 'Answer occupational rating questionnaire',
      label: parseInt(component)
    });
  }

  hasErrors(e) {
    this.setState({
      hasErrors: e
    });
  }

  occupationalRatingDropDown = (event) => {
    event.persist();
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        occupationalRating: event.target.value
      }
    }));
  }

  setOccupationalRatingPolice() {
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        occupationalRating: 'High risk'
      }
    }));

    // create a call back when police is selected to force
    // IP protection length and wait period
    // this.setState(update(this.state, {
    //   insuranceCoverInputs: {$set: 2}
    //
    //
    // }), this.props.callbackIPdetails(this.state.insuranceCoverInputs));
  }

  resetOccupationalRating() {
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        occupationalRating: null
      }
    }), () => this.props.callbackParent(this.state.userInputs.occupationalRating));
  }

  resetUserInputs() {
    this.setState({
      occupationalRating: null
    }, this.props.callbackParent(this.state.occupationalRating));
  }

  resetQuestions() {
    this.setState({
      questionsAnswered: null
    }, this.props.callbackParent(this.state.questionsAnswered));
  }


handleEditClick(e) {
  e.preventDefault();
  ReactGA.event({
    category: 'Tell us about yourself',
    action: 'User clicked Edit button'
  });
  this.setState({
    panel1Edit: false,
    step1Inactive: false,
    step2Inactive: true,
    step3Inactive: true
  },() => this.props.panelVisible(this.state.step1Inactive));
}

handleClick(e) {
  e.preventDefault();

  ReactGA.event({
    category: 'Tell us about yourself',
    action: 'User clicked Next button'
  });
  this.setState({
    panel1Edit: true,
    step1Inactive: true,
    step2Inactive: false
  },
  () => this.props.panelVisible(this.state.step1Inactive),
  () => this.props.panelVisible(this.state.step2Inactive),
  () => this.props.panelVisible(this.state.panel1Edit));

  this.props.callbackParent(this.state.userInputs);
}

radioOnChange(e) {
  this.setState(prevState => ({
    userInputs: {
      ...prevState.userInputs,
      riskRating: e
    }
  }));
  if(e === true) {
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        riskRating: '1'
      }
    }));
  } else {
    this.setState(prevState => ({
      userInputs: {
        ...prevState.userInputs,
        riskRating: '0'
      }
    }));
  }
}

occupationalContent() {
  return (<p>In order to provide you with a premium estimate, we need to determine your occupational rating. Your occupational rating tells us about the level of risk you experience at work.</p>);
}

existingMember() {
  if(this.state.userInputs.existingMember === '0' && this.state.userInputs.occupationalRating === null) {
  return (
      <div>
        {this.occupationalContent()}
        <p>Please complete the questionnaire:</p>
        <div className="tab-content">
        <GetHelp callbackParent={this.occupationalRatingSelect} callbackQuestions={this.questionsAnswered}/></div>
      </div>
    );
  } else if(this.state.userInputs.existingMember === '0' && this.state.userInputs.occupationalRating !== null && this.state.questionsAnswered == true) {
    return(
      <div className="hidden-small-and-below">{this.showRating()}</div>
    );
  }
}

  getPoliceOfficer() {
    if(this.state.userInputs.existingMember === '1') {
      return (
        <RadioToggle id={"policeOffice"} name={"policeOfficer"} onChange={this.police} controlLabel={"Are you a police officer?"}/>
      );
    }
  }

  getWarning() {
    if(this.state.userInputs.police === '1') {
      return (
        <div>{this.showRating()}
        <div className="warning-message"><span className="image"></span><p>As a Police Officer you automatically pay premiums at the default police rate.
        If you personalise your cover then you pay premiums at the high risk rate, unless this is a decrease from your
        default cover amount. If you decrease cover, you’ll continue to pay premiums at the default police rate.
        This estimator assumes you are looking to increase cover and uses the high risk rate. For anything else, please <a href="https://memberonline.qsuper.qld.gov.au/" target="_blank">log into Member Online</a>.</p></div>
        </div>
      );
    }
  }

  getQuestionnaire() {
    if(this.state.userInputs.existingMember === '1' && this.state.userInputs.police === '0' && this.state.userInputs.occupationalRating === null) {
      return (
        <div>
        {this.occupationalContent()}
          <SelectRiskRating name={'riskOptions'} onChange={this.riskRating}  />
          {
            this.state.userInputs.riskRating === '0'
            ? this.getHelpRating()
            : this.selectOwnRating()
         }
        </div>
      );
  } else if(this.state.userInputs.police === '0' && this.state.userInputs.existingMember === '1' && this.state.userInputs.occupationalRating !== null && this.state.questionsAnswered === null) {
    return (

      <div>
        {this.occupationalContent()}
        <SelectRiskRating name={'riskOptions'} onChange={this.riskRating}  />
        {
          this.state.userInputs.riskRating === '0'
          ? this.getHelpRating()
          : this.selectOwnRating()
       }
      </div>
    );
  } else if(this.state.userInputs.existingMember === '1' && this.state.userInputs.police === '0' && this.state.userInputs.occupationalRating !== null && this.state.userInputs.riskRating === '0') {
      return(
        this.showRating()
      );
  }
}

  getHelpRating() {
    return (<div className="tab-content"><GetHelp callbackParent={this.occupationalRatingSelect} callbackQuestions={this.questionsAnswered} /></div>);
  }

  selectOwnRating() {
    return (<div className="tab-content"><SelectOccupationRating name={"occupationalRating"} occupationalRating={this.state.userInputs.occupationalRating} onChange={this.occupationalRatingSelect}/></div>);
  }

  showRating() {
    return (<div>Your QSuper occupational rating is: <span className="occupational-rating">{this.state.userInputs.occupationalRating}</span></div>);
  }

  getMobile() {        
    if(this.state.userInputs.police === '0' && this.state.userInputs.existingMember === '1' && this.state.userInputs.occupationalRating === null) {      
      return(
        <div>
        {this.occupationalContent()}
        <RadioCheckbox
          onChange={this.radioOnChange}
          label={'Complete our occupational rating questionnaire'}
        />
        {
          this.state.userInputs.riskRating === '0'
          ? (<span><div className="text-center">OR</div>
            <SelectOptions simpleSelect active={this.props.active} items={this.props.occupationalRating} handleChange={this.occupationalRatingDropDown}/>
            <p>Please ensure you select the correct rating, otherwise your premium estimate may be incorrect.</p></span>
            )
          : <div className="tab-content"><GetHelp callbackParent={this.occupationalRatingSelect} callbackQuestions={this.questionsAnswered} /></div>
        }
        </div>
      );
    } else if(this.state.userInputs.police === '0' && this.state.questionsAnswered === true && this.state.userInputs.occupationalRating !== null) {
      return(this.showRating());
    } else if(this.state.userInputs.police === '0' && this.state.userInputs.occupationalRating !== null && this.state.userInputs.riskRating === '0') {
      return(this.showRating());
    }
  }

  enableNextButton() {
    if(this.state.hasErrors !== true && this.state.userInputs.age !== null && this.state.userInputs.existingMember !== null && this.state.userInputs.police !== null && this.state.userInputs.occupationalRating !== null) {
      return (
        <a href="#" disabled={false} className={classnames('next-button', {inactive: this.props.step1Inactive})} onClick={this.handleClick}>Next</a>
      );
    } else {
      return (
        <a href="#" disabled={true} className={classnames('next-button', {inactive: this.props.step1Inactive})} onClick={this.handleClick}>Next</a>
      );
    }
  }


  render() {
    const getAgeErrors = (component) => this.hasErrors(component);

    return (
      <div className={classnames('panel', {inactive: this.props.step1Inactive})}>
      <div className="panel--title">
        <h2>1. Tell us about yourself</h2>
      </div>
      <div className={classnames('panel--content', {'edit-mode': this.state.panel1Edit})}>
      <p> We'll need to get to know you a little better to estimate your premiums. Let's get started.</p>
        <LabelInput label={"What's your age?"} onBlur={this.ageBlur} update={this.age} type={"number"} pattern={"[0-9]*"} validateAge callbackParent={getAgeErrors}/>
        <RadioToggle id={'existingMember'} name={'existingMember'} onChange={this.getExistingMember} controlLabel={'Do you have an existing QSuper account?'}/>
          {this.existingMember()}
          {this.getPoliceOfficer()}
          {this.getWarning()}
        <div className="hidden-small-and-below">
          {this.getQuestionnaire()}
        </div>
        <div className="hidden-medium-and-above">
          {this.getMobile()}
        </div>

        {
          !this.props.step1Inactive
          ? this.enableNextButton()
          : null
        }
        </div>
        {
          this.state.panel1Edit
          ? <a href="" className="panel--edit" onClick={this.handleEditClick}>Edit</a>
          : null
        }
      </div>
    );
  }
}

AboutYourself.defaultProps = {
  occupationalRating: [
    {value: '', hidden: 'hidden', label: "Select your QSuper occupational rating"},
    {value: 'Professional', label: "Professional"},
		{value: 'White collar', label: "White collar"},
		{value: 'Standard', label: "Standard"},
    {value: 'High risk', label: "High risk"}
  ],
  callbackParent: function(){},
  panelVisible: function(){},
  step1Inactive: false
};

AboutYourself.propTypes = {
  callbackParent: React.PropTypes.func.isRequired,
  panelVisible: React.PropTypes.func.isRequired,
  step1Inactive: React.PropTypes.bool.isRequired,
  occupationalRating: React.PropTypes.array.isRequired
};

export default AboutYourself;



// WEBPACK FOOTER //
// ./src/components/panels/AboutYourself.js